(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ms-reveal:not(.ms-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ms-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ms-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var heros = document.querySelectorAll('[data-ms-parallax]');
    if (!heros.length || reduce) return;
    var ticking = false;
    function update() {
      heros.forEach(function (h) {
        var r = h.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var k = parseFloat(h.getAttribute('data-ms-parallax')) || 0;
        h.style.setProperty('--ms-parallax', (-r.top * k / 100) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-ms-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, fin = parseFloat(el.getAttribute('data-ms-count')) || 0;
        if (reduce) { el.textContent = fin; return; }
        var t0 = null, dur = 1400;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initKit() {
    document.querySelectorAll('[data-ms-kit]').forEach(function (kit) {
      function activar(n) {
        kit.querySelectorAll('[data-ms-kit-n]').forEach(function (el) {
          el.classList.toggle('is-activo', el.getAttribute('data-ms-kit-n') === n);
        });
      }
      kit.querySelectorAll('[data-ms-kit-n]').forEach(function (el) {
        el.addEventListener('mouseenter', function () { activar(el.getAttribute('data-ms-kit-n')); });
        el.addEventListener('focus', function () { activar(el.getAttribute('data-ms-kit-n')); });
        el.addEventListener('click', function () { activar(el.getAttribute('data-ms-kit-n')); });
      });
      kit.addEventListener('mouseleave', function () { activar(''); });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function initProducto() {
    document.querySelectorAll('[data-ms-producto]').forEach(function (root) {
      // Galería
      var principal = root.querySelector('[data-ms-principal]');
      root.querySelectorAll('[data-ms-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
          root.querySelectorAll('[data-ms-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });

      // Cantidad
      var qty = root.querySelector('[data-ms-qty]');
      root.querySelectorAll('[data-ms-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-ms-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var dataEl = root.querySelector('[data-ms-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var boton = root.querySelector('[data-ms-add]');
      var formato = root.getAttribute('data-money-format');
      if (dataEl && idInput) {
        var variantes = JSON.parse(dataEl.textContent);
        root.querySelectorAll('[data-ms-opcion] input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('[data-ms-opcion]').forEach(function (fs) {
              var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) {
              return x.options.every(function (o, i) { return o === sel[i]; });
            });
            actualizarVariante(v);
          });
        });
      }
      function actualizarVariante(v) {
        var precioEls = document.querySelectorAll('[data-ms-precio]');
        var antesEls = document.querySelectorAll('[data-ms-precio-antes]');
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = boton.getAttribute('data-txt-nodisp'); }
          return;
        }
        idInput.value = v.id;
        precioEls.forEach(function (el) { el.textContent = formatMoney(v.price, formato); });
        antesEls.forEach(function (el) {
          el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, formato) : '';
        });
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.getAttribute('data-txt-add') : boton.getAttribute('data-txt-agotado');
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Añadir al carrito con el cajón de Dawn (si existe); si no, envío normal
      if (form && boton) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          if (!window.fetch || !window.FormData) return;
          ev.preventDefault();
          var err = root.querySelector('[data-ms-error]');
          if (err) err.textContent = '';
          boton.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          if (drawer) {
            fd.append('sections', 'cart-drawer,cart-icon-bubble');
            fd.append('sections_url', window.location.pathname);
          }
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              boton.removeAttribute('aria-busy');
              if (res.status) { if (err) err.textContent = res.description || res.message; return; }
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.classList.remove('is-empty');
                drawer.renderContents(res);
              } else {
                window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
              }
            })
            .catch(function () { boton.removeAttribute('aria-busy'); form.submit(); });
        });
      }

      // Barra fija de compra
      var barra = document.querySelector('[data-ms-barra]');
      var objetivo = boton || root.querySelector('.ms-prod__apps') || root.querySelector('.ms-prod__info');
      if (barra && objetivo && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
            barra.classList.toggle('is-visible', pasado);
          });
        });
        io.observe(objetivo);
        var barraBtn = barra.querySelector('button');
        if (barraBtn) barraBtn.addEventListener('click', function () {
          if (boton && !boton.disabled) boton.click();
          else objetivo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll() {
    document.documentElement.classList.remove('ms-sin-js');
    initReveal(); initParallax(); initCountUp(); initKit(); initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Editor de Shopify: re-inicializar al añadir/editar secciones
  document.addEventListener('shopify:section:load', function () { initReveal(); initParallax(); initCountUp(); initKit(); });
})();
